module.exports = __webpack_public_path__ + "img/_DSC7941.c1138d9b.jpg";